export const TRA_HANG_PERMISSION_CODES = {
  WEB_BH_TRA_HANG_LIST: 'WEB_BH_TRA_HANG_LIST',
  WEB_BH_TRA_HANG_DETAIL: 'WEB_BH_TRA_HANG_DETAIL',
  WEB_BH_TRA_HANG_ADD: 'WEB_BH_TRA_HANG_ADD',
  WEB_BH_TRA_HANG_EDIT: 'WEB_BH_TRA_HANG_EDIT',
  WEB_BH_TRA_HANG_DELETE: 'WEB_BH_TRA_HANG_DELETE',
  WEB_BH_TRA_HANG_CANCEL: 'WEB_BH_TRA_HANG_CANCEL',
  WEB_BH_TRA_HANG_PAY: 'WEB_BH_TRA_HANG_PAY',
  WEB_BH_TRA_HANG_EXPORT: 'WEB_BH_TRA_HANG_EXPORT',
} as const

export const TRA_HANG_MUTATE_PERMISSIONS = [
  TRA_HANG_PERMISSION_CODES.WEB_BH_TRA_HANG_ADD,
  TRA_HANG_PERMISSION_CODES.WEB_BH_TRA_HANG_EDIT,
  TRA_HANG_PERMISSION_CODES.WEB_BH_TRA_HANG_DELETE,
  TRA_HANG_PERMISSION_CODES.WEB_BH_TRA_HANG_CANCEL,
  TRA_HANG_PERMISSION_CODES.WEB_BH_TRA_HANG_PAY,
  TRA_HANG_PERMISSION_CODES.WEB_BH_TRA_HANG_EXPORT,
] as const
